/* 同意文 */
import React from 'react';
import { Card, Form } from 'react-bootstrap';
import HtmlParser from './HtmlParser';
import RowTemplate from '../atoms/RowTemplate';
import Messages from './Messages';

interface Props {
  id_name: string;
  label: string;
  content: string;
  checked: boolean;
  disabled: boolean;
  need?: boolean;
  message?: string;
  help_msg?: string;
  check_box_title?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleBlur?: () => void;
}

const Clause: React.FC<Props> = ({
  id_name,
  label,
  content,
  checked,
  disabled,
  need,
  message,
  help_msg,
  check_box_title,
  onChange,
  handleBlur,
}) => {
  return (
    <>
      <RowTemplate
        label={label}
        need={need}
        disabled={disabled}
        content={
          <>
            <label className="check-box-label">
              <Form.Check
                id={`checkbox-${id_name}`}
                type="checkbox"
                label={check_box_title}
                checked={checked}
                disabled={disabled}
                onChange={onChange}
                onBlur={handleBlur}
              />
            </label>
            <Card className="block mx-auto col-xs-11 col-sm-11 col-md-12 col-11 px-0">
              <Card.Body>
                <HtmlParser html={content} />
                {disabled || <Messages help_msg={help_msg} valid_msg={message} />}
              </Card.Body>
            </Card>
          </>
        }
      />
    </>
  );
};

export default Clause;
